'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WordpressFAQ from '@/components/faqs/wordpress-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Ensure Intuitive and Responsive Web Solutions with Custom WordPress Development Services"
                alt="WordPress Development"
                title="WordPress Development"
                width={1090}
                height={604}
                path={'wordpress-hero'}
                bgPath={'hero-bg-grunge'}
            >
                WordPress<div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="WordPress" />
            <ContetVideoSection title="Customize Your Business with Robust and Scalable WordPress CMS">
                <>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Being open-source in nature, WordPress is one of the most powerful and widely accepted frameworks majorly
                        used in the development of blogs, e-commerce, social networks, and other functionalities. Originally,
                        WordPress development services were built to showcase typography elegantly, its rich design, wide plugin
                        directory, and robust template converted WordPress into a highly approached platform used to build custom
                        CMS solutions backed by PHP coding. So, if you want to compliment your brand with the best WordPress
                        solution, Moweb is the ultimate address for you.
                    </p>
                </>
            </ContetVideoSection>
            <HireProcess
                bg="bg-wordpress"
                pageTitle="Hire WordPress Developers To Build Cutting-Edge Digital Products"
                desc="Develop custom WordPress themes, plugins, and functionalities to create unique and user-friendly digital products."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For WordPress Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best WordPress Developers"
                desc=" Select from different engagement models to hire WordPress Developers for your business needs. You will be responsible for designing, developing, and maintaining our WordPress-based websites. Your expertise will contribute to creating visually appealing, user-friendly, and high-performance websites."
            />
            <TechnologyFaq title="FAQs On WordPress Development Services" bg="bg-wordpress">
                <WordpressFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
